import BaseAppService from "application/platform/base-app.service";
import { ACTION_TYPES, useHomeDispatch } from "./home-context";
import MunicipalPortalAAppService from "application/platform/municipal-portal-service";
import { INewsPagedRequest } from "models/request/news-paged-request";
import { ILinkServicesListRequest } from "models/request/link-services-list-request";
import { IBannersListRequest } from "models/request/banners-list-request";
import Document from "../../../assets/icons/services-icons/document.svg";
import Money from "../../../assets/icons/services-icons/money-paper.svg";
import Phone from "../../../assets/icons/services-icons/phone.svg";
import Bulb from "../../../assets/icons/services-icons/bulb.svg";
import Users from "../../../assets/icons/services-icons/users.svg";
import Home from "../../../assets/icons/services-icons/home.svg";
import Paper from "../../../assets/icons/services-icons/paper.svg";

export const useHomeController = () => {
    const HomeDispatch = useHomeDispatch();


    async function listNews(count: number) {
        try {
            const news = await MunicipalPortalAAppService.listNews({ page: 0, pageSize: count } as INewsPagedRequest);

            HomeDispatch({
                type: ACTION_TYPES.setNews,
                payload: news,
            });
        } catch (error) {
            console.log(error);

        }
    }

    async function listLinkServices(count: number) {
        try {
            const linkServices = await MunicipalPortalAAppService.listLinkServices({ count } as ILinkServicesListRequest);

            HomeDispatch({
                type: ACTION_TYPES.setLinkServices,
                payload: linkServices,
            });
        } catch (error) {
            console.log(error);

        }
    }

    async function listBanners() {
        try {
            const banners = await MunicipalPortalAAppService.listBanners({} as IBannersListRequest);

            HomeDispatch({
                type: ACTION_TYPES.setBanners,
                payload: banners,
            });
        } catch (error) {
            console.log(error);

        }
    }

    function convertIcon(iconNumber: number): string {
        switch (iconNumber) {
            case 1:
                return Document;
            case 2:
                return Phone;
            case 3:
                return Money;
            case 4:
                return Bulb;
            case 5:
                return Users;
            case 6:
                return Home;
            case 7:
                return Paper;
            default:
                return Home;
        }
    }
    return {
        listNews, listBanners, listLinkServices,convertIcon
    };
}